import { makeStyles } from 'tss-react/mui';
import { PRIMARY_PAYMENT_DARK, PRIMARY_PAYMENT_DEFAULT, SECONDARY_PAYMENT_10, WHITE } from 'src/global/theme/colors';

export const styles = makeStyles()(() => {
  return {
    panel: {
      backgroundColor: WHITE,
      borderRadius: '10px',
      border: '1px solid #E0E0E0',
      padding: '16px',
      margin: '0 40px'
    },
    // El dia elegido en el calendario: el verde del theme es el medio (#3CAB6D),
    // y sobre ese fondo MUI calcula texto negro, que casi no se lee. Mismo verde
    // y mismo texto blanco que los botones del panel.
    pickerPaper: {
      '& .MuiPickersDay-root.Mui-selected': {
        backgroundColor: PRIMARY_PAYMENT_DEFAULT,
        color: WHITE,
        fontWeight: 500,
        '&:hover, &:focus': {
          backgroundColor: PRIMARY_PAYMENT_DARK
        }
      },
      '& .MuiPickersDay-root.MuiPickersDay-today:not(.Mui-selected)': {
        borderColor: PRIMARY_PAYMENT_DEFAULT
      }
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '12px'
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '12px',
      marginTop: '16px'
    },
    // Los tres botones comparten alto, tipografia y familia de verde con
    // "Descargar CSV" (el del design system), para que lean como un grupo.
    actionButton: {
      height: '48px',
      padding: '4px 24px',
      borderRadius: '8px',
      fontSize: '15px',
      fontWeight: 400,
      lineHeight: '22px',
      textTransform: 'none'
    },
    clearButton: {
      color: PRIMARY_PAYMENT_DEFAULT,
      '&:hover': {
        backgroundColor: SECONDARY_PAYMENT_10
      }
    },
    applyButton: {
      color: PRIMARY_PAYMENT_DEFAULT,
      borderColor: PRIMARY_PAYMENT_DEFAULT,
      '&:hover': {
        borderColor: PRIMARY_PAYMENT_DARK,
        backgroundColor: SECONDARY_PAYMENT_10
      }
    }
  };
});
